<template>
  <v-container fluid class="fade-in mx-5">
    <v-row>
      <v-col xs="12" center class="pt-2 pb-0">
        <h1>Search offices by people</h1>
      </v-col>
    </v-row>

    <!-- wrap  -->
    <v-row data-app wrap class="search-ctrls elevation-3">
      <v-col sm="10" md="10">
        <v-text-field
          v-model="term"
          hide-details="false"
          placeholder="Search for people by first name, last name or email"
          @keypress="onKeyUp"
        ></v-text-field>

      </v-col>
      <v-col sm="10" md="2" class="d-flex align-end">
           <v-btn color="primary" dark @click="onSearchClicked">Search</v-btn>
      </v-col>
    </v-row>

    <v-layout data-app wrap row>
      <v-flex xs12>
        <v-data-table :headers="headers" :items="rowData" class="elevation-3">
          <template v-slot:item.link="{ item }">
            <router-link :to="{ name: 'details', params: { id: item.officeId} }">View user's office</router-link>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import router from "@/router";
import { userService } from "@/services/userService";

export default {
  name: "AdminPeopleSearch",
  data: () => ({
    headers: [
      //{ text: "Title", value: "title", align: "start" },
      { text: "User ID", value: "id", align: "start" },
      { text: "Password", value: "showPassword", align: "start" },
      { text: "First name", value: "nameFirst", align: "start" },
      { text: "Last Name", value: "nameLast" },
      { text: "E-mail address", value: "email" },
			{ text: "Phone Number", value: "phone" },
      { text: "Alternate POC 1", value: "altNameFirstAltNameFirst" },
      { text: "Alternate POC 1 E-mail", value: "altEmail" },
      { text: "Alternate POC 2", value: "altNameFirstAltNameFirst2" },
      { text: "Alternate POC 2 E-mail", value: "altEmail2" },
      { text: "Alternate POC 3", value: "altNameFirstAltNameFirst3" },
      { text: "Alternate POC 3 E-mail", value: "altEmail3" },
      { text: "Alternate POC 4", value: "altNameFirstAltNameFirst4" },
      { text: "Alternate POC 4 E-mail", value: "altEmail4" },
      { text: "Alternate POC 5", value: "altNameFirstAltNameFirst5" },
      { text: "Alternate POC 5 E-mail", value: "altEmail5" },
      { text: "Supervisor", value: "supNameFirstSupNameLast" },
      { text: "Supervisor E-mail", value: "supEmail" },
      { text: "Ext.", value: "phoneExt" },
      { text: "City", value: "city" },
      { text: "State", value: "state" },
      { text: "Office Name", value: "officeName" },
      { text: "Office Abbrev.", value: "officeAbbrev" },
      { text: "Office Link", value: "link" }
    ],
    rowData: [],
    term: null
  }),
  methods: {
    onKeyUp: function (evt) {
      if (evt.key === "Enter") {
        this.onSearchClicked();
      }
    },
    onSearchClicked () {
      const me = this;
      userService
        .searchForUser(me.term)
        .then(function (response) {
          me.rowData = response.data.results;
          console.log(response.data);
        })
        .catch(function (err) {
          console.error(err);
        });
    }
  }
};
</script>

<style scoped>
.search-ctrls {
  background-color: aliceblue;
  border: 1px solid #abc0e6;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
  padding: 0 5px;
}
</style>
